import Vue from 'vue';
import gql from 'graphql-tag';
import currencyFilter from 'vue-currency-filter';

const LOCAL_STORAGE_CURRENCY_KEY = 'selectedCurrency';

Vue.localStorage[LOCAL_STORAGE_CURRENCY_KEY] = {
    type: String,
    default: '',
};

const state = Vue.observable({
    selectedCurrency: null,
    currencies: [],
    indexedCurrencies: {},
    changeLocked: false,
});

const plugin = {
    loadCurrencies() {
        return Vue.$graphql
            .query({
                query: gql`
                    query getCurrencies {
                        getCurrencies {
                            _id
                            name
                            title
                            ordering
                            is_default
                            symbol
                        }
                    }
                `,
            })
            .then(r => r.data.getCurrencies)
            .then(currencies => {
                const indexedCurrencies = {};
                currencies.forEach(currency => {
                    indexedCurrencies[currency.name] = currency;
                });
                state.indexedCurrencies = indexedCurrencies;

                state.currencies = currencies;

                if (state.indexedCurrencies[state.selectedCurrency]) {
                    Vue.prototype.$CurrencyFilter.setConfig({
                        ...Vue.prototype.$CurrencyFilter.getConfig(),
                        symbol: state.indexedCurrencies[state.selectedCurrency].symbol,
                    });
                }

                return this.getSelected();
            })
            .catch(() => {
                return [];
            });
    },
    getList() {
        return state.currencies;
    },
    getSelected() {
        if (state.selectedCurrency === null) {
            const localCurrency = Vue.localStorage.get(LOCAL_STORAGE_CURRENCY_KEY);
            if (localCurrency) {
                state.currencies.some(currency => {
                    if (currency.name === localCurrency) {
                        this.setSelected(currency.name);
                        return true;
                    }
                });
            }
            if (!state.selectedCurrency) {
                this.resetToDefault();
            }
        }
        return state.selectedCurrency;
    },
    setSelected(selectedCurrency, force = false) {
        if (!state.changeLocked || force) {
            if (selectedCurrency) {
                Vue.localStorage.set(LOCAL_STORAGE_CURRENCY_KEY, selectedCurrency);
                state.selectedCurrency = selectedCurrency;
                Vue.prototype.$CurrencyFilter.setConfig({
                    ...Vue.prototype.$CurrencyFilter.getConfig(),
                    symbol: state.indexedCurrencies[selectedCurrency].symbol,
                });
            } else {
                this.resetToDefault();
            }
        }
    },
    resetToDefault() {
        state.currencies.some(currency => {
            if (currency.is_default) {
                this.setSelected(currency.name);
                return true;
            }
        });
    },
    lockChange() {
        state.changeLocked = true;
    },
    unlockChange() {
        state.changeLocked = false;
    },
};

export default {
    install(Vue, options) {
        Vue.$currency = plugin;
        Vue.prototype.$currency = plugin;

        plugin.loadCurrencies();

        Vue.use(currencyFilter, {
            ...options,
            symbol: Vue.localStorage.get(LOCAL_STORAGE_CURRENCY_KEY),
        });

        Vue.filter('currency', function(value) {
            if (isNaN(value)) {
                return value;
            }
            if (value === undefined) {
                return NaN;
            }
            if (['number', 'string'].includes(typeof value)) {
                return Vue.options.filters[options.name](value);
            }
        });
    },
};
